import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function Hero() {
  return (
    <section className="relative mt-16 md:mt-20 min-h-[420px] md:min-h-[600px] h-auto flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <ImagePlaceholder
          src="https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20a%20roller%20shutter%20on%20a%20residential%20house%20exterior%2C%20wearing%20work%20uniform%20with%20tools%2C%20warm%20daylight%2C%20clean%20modern%20French%20suburban%20setting%2C%20realistic%20service%20photography%20showing%20quality%20craftsmanship%2C%20professional%20repairman%20at%20work%2C%20editorial%20style%20with%20natural%20colors%20and%20soft%20lighting&width=1600&height=900&seq=hero-reparateur-2026&orientation=landscape"
          alt="Sangle de volet roulant usée et effilochée en gros plan"
          className="absolute inset-0 w-full h-full"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-[#143A66]/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-8 md:py-16">
        <div className="max-w-[80%] mx-auto">
          <div className="max-w-3xl text-center">
            <h1 className="text-white text-2xl md:text-4xl lg:text-[44px] font-extrabold leading-[1.1] mb-3 md:mb-5 animate-hero-fade-up">
              Remplacement de sangle de volet roulant à Strasbourg
            </h1>
            <p className="text-white/90 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-5 md:mb-8 animate-hero-fade-up animate-delay-100">
              Sangle effilochée, cassée ou bloquée : nous remplaçons rapidement les sangles et cordons de volets roulants, toutes marques.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-3 mb-6 md:mb-10 animate-hero-fade-up animate-delay-200">
              <a
                href="tel:0374473240"
                className="inline-flex items-center justify-center gap-2 bg-brand-cyan text-white px-5 py-3 md:px-6 md:py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect w-full sm:w-auto sm:min-w-[260px] text-center overflow-hidden"
              >
                <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
                Appeler le 03 74 47 32 40
              </a>
              <a
                href="#devis"
                className="inline-flex items-center justify-center gap-2 bg-transparent border border-white text-white px-5 py-3 md:px-6 md:py-4 rounded-full font-semibold text-base hover:bg-white/10 transition-all duration-200 btn-hover-effect w-full sm:w-auto sm:min-w-[260px] text-center overflow-hidden"
              >
                Devis gratuit
              </a>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 max-w-xl mx-auto">
              <div className="flex items-center gap-2.5 animate-hero-fade-up animate-delay-300">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20">
                  <i className="ri-time-line text-white text-base"></i>
                </div>
                <span className="text-white/90 text-xs md:text-sm font-medium">Intervention en 24h</span>
              </div>
              <div className="flex items-center gap-2.5 animate-hero-fade-up animate-delay-400">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20">
                  <i className="ri-file-list-3-line text-white text-base"></i>
                </div>
                <span className="text-white/90 text-xs md:text-sm font-medium">Devis gratuit</span>
              </div>
              <div className="flex items-center gap-2.5 animate-hero-fade-up animate-delay-500">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20">
                  <i className="ri-shield-check-line text-white text-base"></i>
                </div>
                <span className="text-white/90 text-xs md:text-sm font-medium">Toutes marques</span>
              </div>
              <div className="flex items-center gap-2.5 animate-hero-fade-up animate-delay-600">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20">
                  <i className="ri-shield-check-line text-white text-base"></i>
                </div>
                <span className="text-white/90 text-xs md:text-sm font-medium">Garantie 10 ans</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}